import { __assign, __extends } from "tslib";
import { deepMix } from '@antv/util';
import { Plot } from '../../core/plot';
import { adaptor } from './adaptor';
import { processImageMask } from './utils'; // 注册的shape

import './shapes/word-cloud';

var WordCloud =
/** @class */
function (_super) {
  __extends(WordCloud, _super);

  function WordCloud() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /** 词云图 */


    _this.type = 'word-cloud';
    return _this;
  }
  /**
   * 获取默认的 options 配置项
   */


  WordCloud.prototype.getDefaultOptions = function () {
    return deepMix({}, _super.prototype.getDefaultOptions.call(this), {
      timeInterval: 2000,
      tooltip: {
        showTitle: false,
        showMarkers: false,
        showCrosshairs: false,
        fields: ['text', 'value', 'color'],
        formatter: function formatter(datum) {
          return {
            name: datum.text,
            value: datum.value
          };
        }
      },
      wordStyle: {
        fontFamily: 'Verdana',
        fontWeight: 'normal',
        padding: 1,
        fontSize: [20, 60],
        rotation: [0, 90],
        rotationSteps: 2,
        rotateRatio: 0.5
      }
    });
  };
  /**
   * 覆写父类方法，词云图需要加载图片资源，所以需要异步渲染
   */


  WordCloud.prototype.render = function () {
    var _this = this;

    var imageMask = this.options.imageMask;

    if (!imageMask) {
      // 调用父类渲染函数
      _super.prototype.render.call(this);

      return;
    }

    var handler = function handler(img) {
      _this.options = __assign(__assign({}, _this.options), {
        imageMask: img || null
      }); // 调用父类渲染函数

      _super.prototype.render.call(_this);
    };

    processImageMask(imageMask).then(handler).catch(handler);
  };
  /**
   * 获取 词云图 的适配器
   */


  WordCloud.prototype.getSchemaAdaptor = function () {
    return adaptor;
  };
  /**
   * 覆写父类的方法，因为词云图使用 单独的函数 进行布局，原理上有些不一样
   */


  WordCloud.prototype.triggerResize = function () {
    if (!this.chart.destroyed) {
      // 这里解决了重渲染时字体变的透明的问题
      this.chart.clear(); // 当整个词云图图表的宽高信息发生变化时，每个词语的坐标
      // 需要重新执行 adaptor，执行词云图的布局函数，不然会出现布局错乱，
      // 如相邻词语重叠的情况。

      this.execAdaptor(); // 执行父类的方法

      _super.prototype.triggerResize.call(this);
    }
  };

  return WordCloud;
}(Plot);

export { WordCloud };